export const isProduction = process.env.REACT_APP_RUNTIME === 'production';

export const globalWKLink = ((): ReturnType<Window['WKLink']['getApi']> => {
  if (!window.WKLink || !window.WKLink.getApi) {
    return {};
  }
  const env = process.env.REACT_APP_RUNTIME as 'development' | 'dbg' | 'production';

  const envToApi = {
    development: () => window.WKLink.getApi('lizhiweike.com', 'dev'),
    dbg: () => window.WKLink.getApi(window.window.location.hostname, 'dev'),
    // 生产环境的配置，不要随意变更。
    production: () => window.WKLink.getApi(window.location.hostname, 'prod')
  };

  if (!envToApi[env]) {
    return {};
  }
  return envToApi[env]() || {};
})();

// 主站URL配置，优先使用globalWKLink中的配置，否则使用Session中的预设配置
const PRESET_MAIN_URL =
  globalWKLink.wk ||
  (window.Session && window.Session.preset_config && window.Session.preset_config.mainUrl);

// API基础URL配置，优先使用globalWKLink中的配置，否则使用Session中的预设配置
const PRESET_BASE_URL =
  globalWKLink.main ||
  (window.Session && window.Session.preset_config && window.Session.preset_config.baseUrl);

// 生产环境#api 请求
const prodApiConfig = {
  BASE_URL: PRESET_BASE_URL || 'https://apiv1.lizhiweike.com',
  ADMIN_BASE_URL: globalWKLink.admin || 'https://admin.lizhiweike.com',
  WFW_BASE_URL: globalWKLink.gateway || 'https://gateway-weike.lizhiweike.com',
  NEW_GATEWAY_URL: globalWKLink.apiGw || 'https://api-gw.lizhiweike.com'
};
// 生产环境#页面路径跳转
const prodPageConfig = {
  MAIN_URL: PRESET_MAIN_URL || 'https://m.lizhiweike.com',
  ADMIN_URL: globalWKLink.adminMain || 'https://admin.lizhiweike.com',
  SHARE_URL: location.origin
};
// 生产环境# host 配置
const prodConfig = {
  WX_APP_ID: 'wx3502aeb0c3639966',
  ...prodApiConfig,
  ...prodPageConfig
};

// 测试环境#api 请求
const devApiConfig = {
  BASE_URL: PRESET_BASE_URL || `https://dbg.lizhiweike.com`,
  ADMIN_BASE_URL: globalWKLink.admin || `https://dev.admin.lizhiweike.com`,
  WFW_BASE_URL: globalWKLink.gateway || `https://gateway.dev2.weike.fm`,
  NEW_GATEWAY_URL: globalWKLink.apiGw || `https://api.dev1.weike.fm`
};
// 测试环境#页面路径跳转
const devPageConfig = {
  MAIN_URL: PRESET_MAIN_URL || `https://dbg.lizhiweike.com`,
  ADMIN_URL: globalWKLink.adminMain || `https://dev.admin.lizhiweike.com`,
  SHARE_URL: globalWKLink.share || 'https://dbg.lizhiweike.com'
};
// 测试环境# host 配置
const devConfig: typeof prodConfig = {
  WX_APP_ID: 'wx3502aeb0c3639966',
  ...devApiConfig,
  ...devPageConfig
};

export const Config = isProduction ? prodConfig : devConfig;

/**
 * 替换任意链接中的域名为新域名
 * @param {string} url 原始链接
 * @param {string} newBase 新域名
 * @returns 替换域名后的链接
 */
export function replaceDomain(url: string, newBase: string) {
  try {
    const original = new URL(url);
    const base = new URL(newBase);
    return `${base.origin}${original.pathname}${original.search}${original.hash}`;
  } catch (err) {
    // console.error('Invalid URL:', url)
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/services/lib/config.ts